import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-10.801215, 165.809623, 5.2],
  [-10.801225, 165.809494, 5.2],
  [-10.801234, 165.809366, 5.2],
  [-10.801241, 165.809237, 5.4],
  [-10.801249, 165.809119, 5.4],
  [-10.801258, 165.80899, 5.6],
  [-10.801265, 165.808872, 5.6],
  [-10.801276, 165.808754, 5.6],
  [-10.801288, 165.808625, 5.8],
  [-10.801301, 165.808518, 5.8],
];

export default stream;
